import type { TdHTMLAttributes } from 'react';

import { useDataTableContext } from './contexts/DataTableContext';
import { DATA_TABLE_SIZE_CLASSES } from './sizeClasses';
import { cn } from '../../../utils/cn';

type Props = TdHTMLAttributes<HTMLTableCellElement>;

export const DataTableCell: React.FC<Props> = ({ className, ...props }) => {
    const { size } = useDataTableContext();
    const { cell } = DATA_TABLE_SIZE_CLASSES[size];

    return <td className={cn(cell, className)} {...props} />;
};
